module.exports = __webpack_public_path__ + "0c9bcea1a7e67a9d6e66e0fbd61d5239.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-1050.jpg
// module id = 504
// module chunks = 0